import api from './api';
import { formatOrder, RawOrder } from './helper';
import { Order } from './typings';

const ORDER_URL = '/api/food_counter/order';

export const fetchOrders = async (warehouseId: number): Promise<Order[]> => {
  const response = await api({
    url: `${ORDER_URL}/?state=placed&warehouse=${warehouseId}`,
    method: 'GET',
  });
  const orders = response.data as RawOrder[];
  return orders.map(formatOrder);
};

export const validateOrder = async (orderId: number) => {
  await api({
    url: `${ORDER_URL}/${orderId}/`,
    method: 'POST',
  });
};

export const cancelOrder = async (orderId: number) => {
  await api({
    url: `${ORDER_URL}/${orderId}/`,
    method: 'DELETE',
  });
};
